<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <template v-if="!loading">
      <template
        v-if="state.config.cambia_aprobador == true && state.nivel_aprobacion != 0 && aprobadores.length > 0"
      >
        <div class="w-11/12 md:w-full mx-auto">
          <div
            class="text-center mb-8 text-zt-lg"
            :class="primaryTextClass"
          >{{ $t('message.licenseComponent.licenseBox.approverTitle') }}</div>
          <div>
            <v-select
              solo
              class="selectLicenseProperty"
              color="#FFFFFF"
              item-text="data"
              item-value="id"
              :items="aprobadores"
              :value="aprobador.id"
              v-model="aprobador"
              return-object
              :label="$t('message.licenseComponent.licenseBox.approver')"
              data-vs-select="approver"
            ></v-select>
          </div>
        </div>
      </template>
      <div class="w-11/12 mx-auto md:w-full">
        <div
          class="text-center mb-8 text-zt-lg"
          :class="primaryTextClass"
        >{{ $t('message.licenseComponent.licenseBox.commentLabel') }}</div>
        <div class="textAreaStep3">
          <v-textarea
            solo
            counter="1500"
            maxlength="1500"
            v-model="observacion"
            :value="observacion"
            data-vs-textarea="observations"
          ></v-textarea>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="py-20">
        <vue-loading
          background-color="rgba(0,0,0,0.0)"
          :color="primaryLoadingColor"
          :width="100"
          :height="100"
          :is-full-page="false"
          :active="loading"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Licenses from "@/apiClient/Licenses"

export default {
  inject: ['state', 'mutations'],
  props: {
    aprobadorSeleccionado: {
      type: Object,
      default: {}
    },
    observaciones: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      licenses: Licenses,
      loading: false,
      aprobadores: [],
      aprobador: this.aprobadorSeleccionado,
      observacion: this.state.request.observaciones
    }
  },
  computed: {
    isInIframe() {
      return window.self !== window.top
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100'
    },
    primaryLoadingColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3'
    }
  },
  created() {
    this.licenses = new Licenses();
    this.getUserApprovers()
  },
  watch: {
    aprobador() {
      this.$emit('set-approver', this.aprobador)
    },
    observacion(newVal, oldVal) {
      this.mutations.addParamToRequest({observaciones: newVal})
    }
  },
  methods: {
    getUserApprovers() {
      this.loading = true
      this.licenses
        .getApprovers()
        .then(response => {
          let aprobadores = response.data.results.data
          let aprobadoresFlag = []
          for (let [key, value] of Object.entries(aprobadores)) {
            if (value.es_aprobador === 't') {
              let aprobador = {
                id: value.id,
                data: value.nombre + ' ' + value.apellido,
                legajo: value.numero_legajo
              }
              aprobadoresFlag.push(aprobador)
            }
          }

          this.aprobadores = aprobadoresFlag

          if (_.isEmpty(this.aprobadorSeleccionado) === false) {
            let alreadyExists = false
            let i
            for (i = 0; i < this.aprobadores.length; i++) {
              if (this.aprobadores[i].id === this.aprobadorSeleccionado.id) {
                alreadyExists = true
              }
            }
            if (alreadyExists === false) {
              this.aprobadores.push({
                id: this.aprobadorSeleccionado.id,
                data: this.aprobadorSeleccionado.data
              })
            }
          }
          this.loading = false
        })
    },
  }
}
</script>

<style scoped lang="scss">
/* Estilos para modo iframe */
.text-iframe-primary {
  color: #2694fc !important;
}

.iframe-mode {
  /* V-select colores */
  ::v-deep .v-select {
    .v-input__slot {
      &::before {
        border-color: #2694fc !important;
      }
    }
    
    &.v-input--is-focused {
      .v-input__slot::after {
        border-color: #2694fc !important;
      }
    }
    
    .v-select__selection--comma {
      color: #2694fc !important;
    }
  }

  /* V-textarea colores */
  ::v-deep .v-textarea {
    .v-input__slot {
      &::before {
        border-color: #2694fc !important;
      }
    }
    
    &.v-input--is-focused {
      .v-input__slot::after {
        border-color: #2694fc !important;
      }
    }
    
    /* Counter color */
    .v-counter {
      color: #2694fc !important;
    }
  }
}
</style>